import { Injectable, inject } from '@angular/core';
import { YandexMetricService } from './yandex-metric.service';
import { KeysService } from 'src/app/terminal/keys/keys.service';
import { filter, first, fromEvent, merge, switchMap } from 'rxjs';
import { AuthenticatorService } from './authenticator.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveUserService {

  private keys = inject(KeysService)
  private authenticator = inject(AuthenticatorService)
  private ym = inject(YandexMetricService)

  private delay = 3600_000

  private get lastActiveTime() {
    const t = localStorage.getItem('lastActiveTime')
    if (t) {
      try {
        return parseInt(t)
      } catch { /* empty */ }
    }
    return 0
  }

  private set lastActiveTime(value: number) {
    localStorage.setItem('lastActiveTime', value.toString())
  }

  start() {
    merge(
      fromEvent(document, 'click'),
      fromEvent(document, 'keydown'),
      this.authenticator.auth$.pipe(filter(flag => flag)),
    ).pipe(
      filter(() => Date.now() >= this.lastActiveTime + this.delay),
      switchMap(() => this.keys.keys$.pipe(first())),
    ).subscribe(keys => {
      if (keys.some(k => !k.isDemo && k.canRead)) {
        this.ym.reachActiveUser()
        this.lastActiveTime = Date.now()
      }
    })
  }

}
